<template>
	<div class="content">
		<div class="title-c">
			Reports
		</div>

		<div v-show="tradingType == 'jgx'" class="tab-content tab-space">

			<!-- Order -->
			<div v-show="tabActive == 'orders'" :class="`${tabActive == 'orders' && 'active'}`" id="nav1-link1"
				:aria-expanded="`${tabActive == 'orders' ? 'true' : 'false'}`">

				<Orders></Orders>
			</div>

			<!-- Transactions -->
			<div v-show="tabActive == 'transactions'" :class="`${tabActive == 'transactions' && 'active'}`" id="nav1-link2"
				:aria-expanded="`${tabActive == 'transactions' ? 'true' : 'false'}`">
				<Transactions></Transactions>
			</div>

			<!-- Holdings -->
			<div v-show="tabActive == 'holdings'" :class="`${tabActive == 'holdings' && 'active'}`" id="nav1-link3"
				:aria-expanded="`${tabActive == 'holdings' ? 'true' : 'false'}`">
				<Holdings></Holdings>
			</div>

			<!-- CLIENTS -->
			<div v-show="tabActive == 'clients' && (accountLevel == 'ib' || accountLevel == 'fm')"
				:class="`${tabActive == 'clients' && 'active'}`" id="nav1-link-clients"
				:aria-expanded="`${tabActive == 'clients' ? 'true' : 'false'}`">
				<div class="flex flex--justify-content-between flex--align-items-end mb-14-c">
					<div>
						<ReportsNav />
					</div>
				</div>

				<div class="row">
					<!-- <div class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="transaction"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div> -->

					<!-- <div class="col-auto mb-2 text-left">
						<ExportAsButton class="d-inline-block">
						</ExportAsButton>
					</div> -->
				</div>

				<div class="row">
					<div class="col-12 table-responsive p-0">
						<table class="table table--report text-nowrap">
							<thead style="background-color: #0f0f17">
								<tr class="text-center">
									<th>HIN</th>
									<th>NAME</th>
									<th>ALLOW TRADE</th>
									<th>ACCOUNT BALANCE</th>
								</tr>
							</thead>
							<tbody v-if="apiStatusGetClients == 'loading'">
								<tr>
									<td class="text-center" colspan="4">
										<Loader size_prop="10em"></Loader>
									</td>
								</tr>
							</tbody>

							<tbody v-else>
								<tr v-for="client in clients" :key="client.hin">
									<td>{{ client.hin }}</td>
									<td>{{ client.name }}</td>
									<!-- <td class="text-center">{{ (client.allowTrade) ? 'Yes' : 'No' }}</td> -->
									<td class="text-center">Yes</td>
									<td class="text-right">{{ numberFormatExtend(Decimal.mul(client.availableBalance,
										streamingRateBuy).toFixed(2)) }}</td>
									<!-- <td class="text-right">{{ numberFormatExtend(Decimal.mul(client.reservedBalance, streamingRateBuy).toFixed(2)) }}</td> -->
								</tr>
							</tbody>
							<tfoot>

							</tfoot>
						</table>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<Pagination2 :totalData_prop="totalClients" @changePage="setClients">
						</Pagination2>
					</div>
				</div>
			</div>

			<!-- Statements -->
			<div v-show="tabActive == 'statements'" :class="`${tabActive == 'statements' && 'active'}`" id="nav1-link4"
				:aria-expanded="`${tabActive == 'statements' ? 'true' : 'false'}`">
				<div class="row justify-content-center">
					<div class="px-3 mb-3" style="width: 380px !important;">
						<!-- <h5 class="text-left">SELECT A DATE RANGE</h5> -->

						<div class="form-group">
							<label for="startDateStatements">Start Date</label>
							<input type="date" class="form-control" id="startDateStatements">
						</div>

						<div class="form-group">
							<label for="endDateStatements">End Date</label>
							<input type="date" class="form-control" id="endDateStatements">
						</div>


						<!-- <h4>REQUEST NEW CREDIT LIMIT</h4>
						<div class="input-group input-group-lg mb-3">
							<div class="input-group-prepend">
								<span class="input-group-text" id="inputGroup-sizing-sm">AUD $</span>
							</div>
							<input type="number" class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm">
							
								<button class="btn btn-sm" type="button">-</button>
								<button class="btn btn-sm" type="button">+</button>
					
						</div>
						<div class="form-group">
							<textarea class="form-control" placeholder="Optional description" rows="5" style="max-height: 200px;"></textarea>
						</div> -->
					</div>
					<div class="w-100"></div>
					<div class="px-3 text-center" style="width: 380px !important;">
						<div title="Coming Soon text-center">
							<button type="button" class="btn btn-success" disabled>RUN STATEMENT REPORT</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Account balance history -->
			<div v-show="tabActive == 'accountBalanceHistory'" :class="`${tabActive == 'accountBalanceHistory' && 'active'}`"
				id="nav1-link5" :aria-expanded="`${tabActive == 'accountBalanceHistory' ? 'true' : 'false'}`">
				<AccountBalance></AccountBalance>
			</div>

			<!-- Cash In Cash Out -->
			<!-- <div v-if="accountLevel == 'ib'" class="tab-pane" id="nav1-link6" aria-expanded="false">
				<div class="row text-right mb-2">
					<div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="accountBalanceHistory"
							@changeFilterClient="changeFilterClientAccountBalanceHistory"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<Pagination
							:maxPage_prop =	"accountBalanceHistoriesShowed.length"
							@changePage = "accountBalanceHistoriesPageIndex = $event"
							:status_prop = "accountBalanceHistoriesStatus"
						>
						</Pagination>
					</div>
					<div class="col-12 table-responsive p-0">
						<table class="table table--report text-nowrap">
							<thead>
								<tr>
									<th scope="col">DATE</th>
									<th scope="col">TRANSACTION ID</th>
									<th scope="col">DEBIT</th>
									<th scope="col">CREDIT</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="lastTenTransactions.length > 0">
									<tr v-for="(item, index) in lastTenTransactions" :key="index">
										<td>{{ item.date }}</td>
										<td>{{ item.transactionId }}</td>
										<td>{{ item.debit }}</td>
										<td>{{ item.credit }}</td>
									</tr>
								</template>
								<template v-else>
									<tr>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
									</tr>
								</template>
							</tbody>
						</table>

					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
/*eslint-env jquery*/
import axios, { abortController } from '@/api/axios.js'
import Decimal from 'decimal.js'

import Orders from '@/components/reports/orders/Orders.vue'
import Transactions from '@/components/reports/transactions/Transactions.vue'
import Holdings from '@/components/reports/holdings/Holdings.vue'
import AccountBalance from '@/components/reports/account-balance/AccountBalance.vue'

import ReportsNav from '@/components/reports/ReportsNav.vue'
import Pagination from '@/components/Pagination.vue'
import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'
import FilterContract from '@/components/FilterContract.vue'
// import ExportAsButton from '@/components/ExportAsButton.vue'
import FilterDateAndType from '@/components/FilterDateAndType.vue'
import FilterClient from '@/components/FilterClient.vue'
import FilterOrderType from '@/components/FilterOrderType.vue'


export default {
	name: 'Reports',

	components: {
		Orders,
		Transactions,
		Holdings,
		AccountBalance,

		ReportsNav,
		Pagination,
		Pagination2,
		Loader,
		FilterContract,
		// ExportAsButton,
		FilterDateAndType,
		FilterClient,
		FilterOrderType
	},

	data() {
		return {
			Decimal: Decimal,
			accountLevel: this.$store.getters.getAccountLevel,
			contracts: '',
			// products: '',
			hubs: '',

			endOfDayPrices: {},

			transactions: [],
			transactionsStatus: 'loading',

			filterType: 'jgx',

			listClients: [],

			filterContractTransaction: [],
			selectedClientTransaction: 'all',
			filterDateAndTypeTransaction: {
				type: 'day',
				startDate: '',
				endDate: ''
			},

			totalTransactions: 1,
			cancelTokenApiGetTransactions: '',
			cancelTokenApiGetHinTransactions: '',
			orderTypeTransactions: 'all',

			clients: [],
			totalClients: 1,
			apiStatusGetClients: 'idle',

			selectedClientAccountBalanceHistory: 'all',

			accountBalanceHistories: [],
			accountBalanceHistoriesStatus: 'idle',
			currentBalance: {
				availableTradeBalance: 0,
				accountBalance: 0,
				reservedBalance: 0,
				creditLimit: 0,
				availableCredit: 0,
				settlementOwning: 0
			},
			totalAccountBalanceHistory: 1,
			cancelTokenApiGetAccountBalanceHistory: '',
			cancelTokenApiGetHinAccountBalanceHistory: '',

			bankTransactions: [],
			totalBankTransactions: 1,
			apiSkipGetBankTransactions: '0',
			apiStatusGetBankTransactions: 'loading',
			cancelTokenApiBankTransactions: '',

			invoiceLoading: [],

			lastTenTransactions: [],
		}
	},

	computed: {
		tabActive() {
			return this.$store.state.reportToShow
		},

		currency() {
			return this.$store.state.currency
		},
		hin() {
			return this.$store.getters.getHin
		},
		tradingType() {
			return this.$store.state.tradingType
		},

		hubsTemp() {
			return this.$store.state.hubs
		},

		contractsTemp() {
			return this.$store.state.contracts
		},

		products() {
			return this.$store.getters.PRODUCTS
		},

		gold() {
			return this.$store.state.gold
		},

		reservedGold() {
			return this.$store.getters.getReservedGold
		},

		dataOrderFilterStatusSubmitShowed: {
			get: function () {
				let sortedDataOrderFilterStatusSubmit = this.dataOrderFilterStatusSubmit.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
				return this.paginationOrder(sortedDataOrderFilterStatusSubmit)
			},
			set: function (newValue) {
				this.dataOrderFilterStatusSubmit = newValue
			}
		},

		dataOrderFilterStatusFillShowed: {
			get: function () {
				let sortedDataOrderFilterStatusFill = this.dataOrderFilterStatusFill.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
				return this.paginationOrder(sortedDataOrderFilterStatusFill)
			},
			set: function (newValue) {
				this.dataOrderFilterStatusFill = newValue
			}
		},

		dataOrderFilterStatusCancelShowed: {
			get: function () {
				let sortedDataOrderFilterStatusCancel = this.dataOrderFilterStatusCancel.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
				return this.paginationOrder(sortedDataOrderFilterStatusCancel)
			},
			set: function (newValue) {
				this.dataOrderFilterStatusCancel = newValue
			}
		},

		accountBalanceHistoriesShowed: {
			get: function () {
				let sortedAccountBalanceHistories = this.accountBalanceHistories.slice().sort((a, b) => new Date(b.date) - new Date(a.date))
				return this.paginationOrder(sortedAccountBalanceHistories)
			},
			set: function (newValue) {
				this.sortedAccountBalanceHistories = newValue
			}
		},

		currencySymbol() {
			if (this.currency == 'idr') {
				return 'Rp '
			} else {
				return '$'
			}
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		streamingRateBuy() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamBuy
			} else {
				return 1
			}
		},

		streamingRateSell() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamSell
			} else {
				return 1
			}
		},

		availableTradeBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.available_trade_bal
			} else {
				return this.$store.state.balances.available_trade_bal_usd
			}
		},
		accountBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.rdk_balance
			} else {
				return this.$store.state.balances.account_bal
			}
		},
		reservedBalance() {
			if (this.currency == 'idr') {
				if (this.accountLevel == 'client') {
					return this.$store.state.reservedBalanceIdr
				} else {
					return Number(Decimal.mul(this.$store.state.reservedBalanceUsd, this.streamingRateBuy))
				}
			} else {
				return this.$store.state.reservedBalanceUsd
			}
		},

		// watcherHubsContractsProducts() {
		// 	return `${this.hubsTemp}${this.contractsTemp}${this.products}`
		// }
	},

	watch: {
		currency() {
			if (this.accountLevel != 'client' && this.accountLevel != 'lp') {
				this.setListBankTransactions(this.apiSkipGetBankTransactions)
			}
		},

		gold() {
			const firstCall = setInterval(() => {
				if (this.products && this.contractsTemp && this.accountLevel && this.hubsTemp) {
					clearInterval(firstCall)

					this.callSetHoldingFrom = 'watch'
					if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
						// this.setHoldings()
					} else {
						// this.setNewHoldings()
					}
				}
			}, 1000)
		}

		// watcherHubsContractsProducts() {
		// 	this.setTransactions()
		// }
	},

	created() {
		// this.getGetEndOfDayPrices()

		const firstCall = setInterval(() => {
			if (this.products && this.contractsTemp && this.accountLevel && this.hubsTemp) {
				clearInterval(firstCall)

				if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'lp') {
					// this.setListBankTransactions()
					this.setAccountBalanceHistory()
				} else {
					this.setAccountBalanceHistory()
				}
			}
		}, 1000)

		if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
			this.setClients()

			axios.post('/v2/rrs/list_clients', {
				user_id: this.$store.state.userId
			})
		}

		if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
			let urlApi = ''
			if (this.accountLevel == 'ib') {
				urlApi = '/v2/rrs/ib/list/client'
			} else if (this.accountLevel == 'fm') {
				urlApi = '/v2/rrs/fm/list/branch'
			} else {
				urlApi = '/v2/rrs/ccp/list/branch'
			}

			axios.post(urlApi, {
				user_id: this.$store.state.userId
			}).then(response => {
				this.listClients = response.data.data.body
				console.log('Berhasil get list clients for ' + this.accountLevel, response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log("Gagal get list clients for " + this.accountLevel, error.config)
			})
		}
	},

	mounted() {
	},

	methods: {

		paginationOrder(arr) {
			const itemPerPage = 10
			let arrTemp1 = [],
				arrTemp2 = []
			for (let i = 0; i < arr.length; i++) {
				arrTemp1.push(arr[i])
				if ((i + 1) % itemPerPage == 0 || (i == arr.length - 1 && (i + 1) % itemPerPage != 0)) {
					arrTemp2.push(arrTemp1)
					arrTemp1 = []
				}
			}
			return arrTemp2
		},

		invoice(orderMatchId, direction, transactionStatus) {
			// If Transaction Status == On Process, cannot download pdf
			if (transactionStatus == 'On Process') {
				return false
			}

			// this.$router.push('/invoice?order_match_id=' + orderMatchId + '&direction=' + direction)

			this.invoiceLoading.push(orderMatchId)
			axios.post('/v2/igx/reports/pdf/transaction_invoice', {
				order_match_id: orderMatchId,
				direction: direction,
			}).then(response => {
				let datanya = response.data.data.body.data

				// let byte = this.base64ToArrayBuffer(datanya)
				const arrTes = new Uint8Array(datanya)
				let blob = new Blob([arrTes], { type: "application/pdf" })
				console.log('berhasil invoice', response, datanya, arrTes, blob)
				let link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				let fileName = 'trade_confirmation_invoice-' + orderMatchId
				link.download = fileName
				link.click()

				let indexLoading = this.invoiceLoading.indexOf(orderMatchId)
				this.invoiceLoading.splice(indexLoading, 1)

				console.log("berhasil invoice", response)
			}).catch(error => {
				let indexLoading = this.invoiceLoading.indexOf(orderMatchId)
				this.invoiceLoading.splice(indexLoading, 1)

				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log("gagal invoice", error.config)
			})
		},
		base64ToArrayBuffer(base64) {
			let binaryString = window.atob(base64)
			let binaryLen = binaryString.length
			let bytes = new Uint8Array(binaryLen)
			for (let i = 0; i < binaryLen; i++) {
				let ascii = binaryString.charCodeAt(i)
				bytes[i] = ascii
			}
			return bytes
		},

		getGoldById(contractId) {
			return this.$store.getters.goldById(contractId)
		},

		setClientsFilter() {
			axios.post('/v2/rrs/list_clients', {
				user_id: this.$store.state.userId
			}).then(response => {
				this.listClients = response.data.data.body

				console.log('Berhasil setClientsFilter', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('Gagal setClientsFilter', error.config)
			})
		},

		setClients(skip = 0, limit = 10) {
			this.apiStatusGetClients = 'loading'

			axios.post('/v2/rrs/list_clients?offset=' + skip + '&limit=' + limit, {
				user_id: this.$store.state.userId
			}).then(response => {
				const dataResponse = response.data.data.body
				this.totalClients = response.data.data.count

				if (this.totalClients == 0 && dataResponse.length > 0) {
					this.totalClients = this.listClients.length
				}

				this.clients = []

				dataResponse.forEach((value) => {
					this.clients.push({
						'hin': value.attributes.hin,
						'name': value.attributes.name,
						'allowTrade': value.attributes.allowClientTrade,
						'availableBalance': value.attributes.availableTrade,
						'reservedBalance': value.attributes.totalReserveFunds,
					})
				})

				this.apiStatusGetClients = 'success'
				console.log('Berhasil setClients', response, dataResponse, this.clients)
			}).catch(error => {
				this.apiStatusGetClients = 'error'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('Gagal setClients', error.config)
			})
		},

		setAccountBalanceHistory(skip = 0, limit = 10) {
			let urlApi = ''
			let hin = ''
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm' || this.accountLevel == 'ccp') {
				if (this.selectedClientAccountBalanceHistory == 'all') {
					urlApi = '/v2/rrs/specific/balance_history?offset=' + skip + '&limit=' + limit
				} else {
					urlApi = '/v2/rrs/specific/balance_history?hin=' + this.selectedClientAccountBalanceHistory.hin_abx + '&accountId=' + this.selectedClientAccountBalanceHistory.ac_abx
				}
			} else if (this.accountLevel == 'lp') {
				urlApi = '/v2/igx/market-maker/balance_history?offset=' + skip + '&limit=' + limit
				hin = this.$store.getters.getHin
			} else {
				urlApi = '/v2/igx/balance_history?offset=' + skip + '&limit=' + limit
				hin = this.$store.getters.getHin
			}

			if (this.cancelTokenApiGetAccountBalanceHistory) {
				//cancel api get account balance history
				this.cancelTokenApiGetAccountBalanceHistory.controller.abort()
			}
			this.cancelTokenApiGetAccountBalanceHistory = abortController()

			this.accountBalanceHistoriesStatus = 'loading'

			axios.post(urlApi, {
				user_id: this.$store.state.userId
			}, {
				signal: this.cancelTokenApiGetAccountBalanceHistory.signal
			}).then(response => {
				this.accountBalanceHistories = []
				this.currentBalance = {
					availableTradeBalance: 0,
					accountBalance: 0,
					reservedBalance: 0,
					creditLimit: 0,
					availableCredit: 0,
					settlementOwning: 0
				}

				this.totalAccountBalanceHistory = response.data.data.count

				let balanceHistories = response.data.data.body

				if (balanceHistories.length < 1) {
					this.accountBalanceHistoriesStatus = 'success'
				}

				let indexAccountBalanceHistory = 0


				balanceHistories.forEach((balanceHistory) => {
					let dateTemp = new Date(balanceHistory.attributes.createdAt)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					//
					if (this.accountLevel != 'ib' && this.accountLevel != 'fm') {
						if (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' || balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal') {
							return
						}
					} else if ((balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash deposit' && balanceHistory.attributes.amount <= 0) || (balanceHistory.attributes.transactionTypeId.toLowerCase() == 'cash withdrawal' && balanceHistory.attributes.amount >= 0)) {
						return
					}

					const rate = balanceHistory.attributes.rate || this.streamingRate.streamSell

					this.$set(this.accountBalanceHistories, indexAccountBalanceHistory, {
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						effectiveAccountId: response.data.data.hin || hin || '-',
						account: this.$store.getters.getFirstName || '-',
						transactionId: balanceHistory.id,
						transaction: balanceHistory.attributes.transactionTypeId,
						amount: balanceHistory.attributes.amount,
						amountIdr: Decimal.mul(balanceHistory.attributes.amount, rate).toNumber(),
						accountBalance: balanceHistory.attributes.total
					})

					indexAccountBalanceHistory++

				})

				let creditLimit = 0
				let settlementOwning = 0
				let availableCredit = this.currentBalance.creditLimit - this.currentBalance.settlementOwning

				if (this.currency == 'idr') {
					this.currentBalance.creditLimit = creditLimit * this.streamingRate.streamBuy
					this.currentBalance.settlementOwning = settlementOwning * this.streamingRate.streamBuy
					this.currentBalance.availableCredit = availableCredit * this.streamingRate.streamBuy
				} else {
					this.currentBalance.creditLimit = creditLimit
					this.currentBalance.settlementOwning = settlementOwning
					this.currentBalance.availableCredit = availableCredit
				}

				this.accountBalanceHistoriesStatus = 'success'
				console.log('berhasil balance history', response)
			}).catch(error => {
				this.accountBalanceHistoriesStatus = 'idle'
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal balance history', error.config)
			})
		},

		changeFilterClientAccountBalanceHistory(clientData) {
			this.selectedClientAccountBalanceHistory = clientData
			if (this.accountLevel == 'ib' || this.accountLevel == 'fm') {
				this.setListBankTransactions()
			} else {
				this.setAccountBalanceHistory()
			}
		},

		setListBankTransactions(skip = 0, limit = 10) {
			this.apiSkipGetBankTransactions = skip
			this.bankTransactions = []

			let param = ''
			if (this.accountLevel == 'ib') {
				if (this.selectedClientAccountBalanceHistory == 'all') {
					param = '/v2/bank-transaction/ib?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx='
				} else {
					param = '/v2/bank-transaction/ib?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=' + this.selectedClientAccountBalanceHistory.ac_abx
				}
			} else {
				// get selected account level
				let temp = this.selectedClientAccountBalanceHistory.hin_abx
				let selectedAccountLevel = ''
				const template = { IB: 'ib', PB: 'fm', LP: 'lp', PC: 'client' }
				if (temp) {
					selectedAccountLevel = template[temp.substr(0, 2)]
				} else {
					selectedAccountLevel = '-'
				}

				if (this.selectedClientAccountBalanceHistory == 'all') {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=&sponsor_id_abx='
				} else if (selectedAccountLevel == 'ib') {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=&sponsor_id_abx=' + this.selectedClientAccountBalanceHistory.sponsor_id_abx
				} else {
					param = '/v2/bank-transaction/pb?skip=' + skip + '&limit=' + limit + '&start_date=&end_date=&type=&status=&ac_abx=' + this.selectedClientAccountBalanceHistory.ac_abx + '&sponsor_id_abx=' + this.selectedClientAccountBalanceHistory.sponsor_id_abx
				}
			}

			this.apiStatusGetBankTransactions = 'loading'
			if (this.cancelTokenApiBankTransactions) {
				this.cancelTokenApiBankTransactions.controller.abort
			}
			this.cancelTokenApiBankTransactions = abortController()

			axios.post(param, {
				user_id: this.$store.state.userId
			}, {
				signal: this.cancelTokenApiBankTransactions.signal,
			}).then(response => {

				this.totalBankTransactions = response.data.total

				let streamingRate = 1
				if (this.currency == 'usd') {
					streamingRate = this.streamingRate.streamSell
				}

				let history = response.data.data
				for (let i = 0; i < 10; i++) {
					let dateTemp = new Date(history[i].created_at)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					let indexOfStart = history[i].reff_transaction.indexOf("-")
					let transactionId = history[i].reff_transaction.substring(indexOfStart + 1)

					let debit = history[i].type == 'debit' ? this.numberFormatExtend(Decimal.mul(history[i].amount, -1).dividedBy(streamingRate).toFixed(2)) : '-'
					let credit = history[i].type == 'credit' ? this.numberFormatExtend(Decimal.div(history[i].amount, streamingRate).toFixed(2)) : '-'

					this.bankTransactions.push({
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						transactionId: transactionId,
						debit: debit,
						credit: credit
					})
				}

				this.apiStatusGetBankTransactions = 'success'
				console.log('berhasil get list bank transactions', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}

				this.apiStatusGetBankTransactions = 'error'
				console.log('gagal get list bank transactions', error.config)
			})
		},

		getHinByAccountId(accountId) {
			return new Promise((resolve) => {
				axios.get('/v2/rrs/get/hin?accountId=' + accountId
				).then(response => {
					console.log('berhasil get hin by ac id', response)
					resolve(response)
				}).catch(error => {
					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */
						console.log(error.response.data)
						console.log(error.response.status)
						console.log(error.response.headers)
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */
						console.log(error.request)
					} else {
						// Something happened in setting up the request and triggered an Error
						console.log(error.message)
					}
					console.log('gagal get hin by ac id', error.config)
				})
			})
		},

		getLastTenTransactions() {
			axios.get('/v2/transaction?skip=0&limit=10&type=bank'
			).then(response => {
				let streamingRate = 1
				if (this.currency == 'usd') {
					streamingRate = this.streamingRate.streamSell
				}

				let history = response.data.data
				for (let i = 0; i < 10; i++) {
					let dateTemp = new Date(history[i].detail.created_at)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					let indexOfStart = history[i].detail.reff_transaction.indexOf("-")
					let transactionId = history[i].detail.reff_transaction.substring(indexOfStart + 1)

					let debit = history[i].detail.type == 'debit' ? Decimal.mul(history[i].detail.amount, -1).dividedBy(streamingRate).toFixed(2) : '-'
					let credit = history[i].detail.type == 'credit' ? Decimal.div(history[i].detail.amount, streamingRate).toFixed(2) : '-'

					this.lastTenTransactions.push({
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						transactionId: transactionId,
						debit: debit,
						credit: credit
					})
				}

				console.log('berhasil get last 10 transactions', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal get last 10 transactions', error.config)
			})
		},

		getGetEndOfDayPrices() {
			let date = new Date()
			date.setDate(date.getDate() - (((2 + date.getDay()) % 7) || 0))
			date.setHours(7)
			date.setMinutes(0)
			date.setSeconds(0)
			date.setMilliseconds(0)

			axios.get('/v2/igx/end_day_prices?date=' + date.toISOString()
			).then(response => {
				this.endOfDayPrices = response.data.data.body
				console.log('berhasil Get End Of Day Prices', response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					// console.log(error.response.status);
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal Get End Of Day Prices', error.config)
			})
		}

	}
}
</script>

<style scoped>
.c-row-table:hover {
	background-color: rgb(0, 0, 0, 0.3);
	cursor: pointer;
}

.title-c {
	font-size: 1.625rem;
	color: white;
}
</style>
